import { useQuery } from "@tanstack/react-query";

import {
  api,
  ParametersModel,
  ParametersModeledMapLayer,
  ParametersModeledParameter,
  StaticMapOverlaysOverlayBase,
} from "@/lib/api";
import { unwrapAxiosData } from "@/lib/api/query-utils";

export const keys = {
  models: () => ["models"] as const,
  modelParameters: (modelId: string | undefined) =>
    ["models", modelId, "parameters"] as const,
  modelMapLayers: (modelId: string | undefined) => ["models", modelId, "layers"] as const,
  staticMapOverlays: () => ["data", "staticMapOverlays"] as const,
};

export const useModelsQuery = () => {
  return useQuery({
    queryKey: keys.models(),
    queryFn: (): Promise<ParametersModel[]> => unwrapAxiosData(api.parameters.listModels()),
  });
};

export const useModelParametersQuery = (modelId: string | undefined) => {
  return useQuery({
    queryKey: keys.modelParameters(modelId),
    queryFn: (): Promise<ParametersModeledParameter[]> =>
      unwrapAxiosData(api.parameters.listParametersForModel(modelId ?? "")),
    enabled: !!modelId,
  });
};

export const useModelMapLayersQuery = (modelId: string | undefined) => {
  return useQuery({
    queryKey: keys.modelMapLayers(modelId),
    queryFn: (): Promise<ParametersModeledMapLayer[]> =>
      unwrapAxiosData(api.parameters.listMapLayersForModel(modelId ?? "")),
    enabled: !!modelId,
  });
};

export const useStaticMapOverlaysQuery = () => {
  return useQuery({
    queryKey: keys.staticMapOverlays(),
    queryFn: (): Promise<StaticMapOverlaysOverlayBase[]> =>
      unwrapAxiosData(api.data.listStaticMapOverlays()),
  });
};
